import { createSlice } from '@reduxjs/toolkit';
import pushNotificationProvider from 'data-access/push-notifications-provider';
import { RootState } from 'app/store';
import { PushNotification } from 'types/model/push-notification';
import { message } from 'antd';

interface PushNotificationState {
  listNotifications: PushNotification[];
  currentPage: number;
  pageSize: number;
  totalItems: number;
  isLoading: boolean;
}

const DEFAULT_PAGE = 1;
const PAGE_SIZE = 1;

const initialState: PushNotificationState = {
  listNotifications: [],
  currentPage: DEFAULT_PAGE,
  pageSize: PAGE_SIZE,
  totalItems: 0,
  isLoading: false
};

export const pushNotificationSlice = createSlice({
  name: 'pushNotification',
  initialState,
  reducers: {
    getAll: (state, action) => {
      state.listNotifications = action.payload.data.map((e) => ({
        ...e,
        segment_type: e.event_name || '',
        created_by: e.created_by || ''
      }));
      state.totalItems = action.payload.total;
    },
    addNewNotification: (state, action) => {
      state.listNotifications = [
        {
          ...action.payload,
          segment_type: action.payload.event_name || '',
          created_by: action.payload.created_by || ''
        },
        ...state.listNotifications
      ];
    }
  }
});

export const { getAll, addNewNotification } = pushNotificationSlice.actions;

export const getListNotifications = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await pushNotificationProvider.getAllNotifications(params);
      dispatch(getAll(res));
    } catch (err) {
      console.error(err);
    }
  };
};

export const createNotifications = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await pushNotificationProvider.post(params);
      dispatch(addNewNotification(res));
      message.open({
        type: 'success',
        content: 'Đã gửi thông báo thành công!'
      });
    } catch (err) {
      console.error(err);
      message.open({
        type: 'error',
        content: 'Đã xảy ra lỗi khi gửi thông báo.'
      });
    }
  };
};

export const selectListNotifications = (state: RootState) =>
  state.pushNotification.listNotifications;
export const selectNotificationTotal = (state: RootState) => state.pushNotification.totalItems;

export default pushNotificationSlice.reducer;
